import * as Turbo from "@hotwired/turbo";
import { Application } from "@hotwired/stimulus";
import { registerControllers } from "@pandev-srl/better-ui";

const application = Application.start();
application.debug = true;
registerControllers(application);

console.log(application);

// Entry point per Vite
import "../assets/stylesheets/application.css";

// Import all images to include them in Vite manifest
// Images will be available via vite_image_tag helper
import.meta.glob("../assets/images/**/*.{png,jpg,jpeg,gif,svg,webp,avif,ico}", {
  eager: true,
});

// Il tuo codice JavaScript qui
